import React, { useState } from 'react';
import { BackButton } from 'components/Common/MUIStyledComponents';

interface ICommentsProps {
  comments: any;
  setFieldValue: any;
  edit: boolean;
  cur_user: any;
  formatted_dt: string;
}

const Comments: React.FC<ICommentsProps> = (props: ICommentsProps) => {
  const { comments, setFieldValue, edit, cur_user, formatted_dt } = props;
  const [ content, setContent ] = useState('');
  const [ wordCount, setWordCount ] = useState(0);

  const countWords = (e: any) => {
    const res = [];
    const str = e.target.value.replace(/[\t\n\r\.\?\!]/gm, ' ').split(' ');
    str.map((s: any) => {
      const trimStr = s.trim();
      if (trimStr.length > 0) {
        res.push(trimStr);
      }
    });
    setWordCount(res.length);
    setContent(e.target.value);
  };

  const handleAddComment = () => {
    const comment: any = {
      content: content,
      person: `${cur_user.basics.firstName} ${cur_user.basics.lastName}`,
      date: formatted_dt,
    };
    let arr = [];
    if (comments) {
      arr = comments;
      arr.push(comment);
    } else {
      arr = [ comment ];
    }
    setFieldValue('comments', arr);
    setContent('');
  };

  const handleRemoveComment = (name: string) => {
    const arr = comments.filter((com: any) => com.content !== content);
    setFieldValue('commodities', arr);
  };

  return (
    <div className='vault-comments-div'>
      <h3>Comments</h3>

      {comments?.map((com: any, i: number) =>
        <div className='comments-display-container' key={i}>
          <h4 className='comment-content'>{com.content}</h4>
          <p>{com.date} - {com.person}</p>
        </div>
      )}

      <textarea className='vault-comments-input' placeholder='Type here...' onChange={countWords} value={content} disabled={!edit}></textarea>
      <div className='vault-comments-count'>
        <p>Word Count: {wordCount}</p>
        <BackButton onClick={handleAddComment} disabled={!edit}>Add Comment</BackButton>
      </div>
    </div>
  );
};

export default Comments;
